export default __webpack_public_path__ + "static/media/space-evenly-vertical.d11a384a.svg";